export default __webpack_public_path__ + "static/media/cv-temp-one.a79c864a.png";